import $ from 'jquery';
/*global map_data*/
/*global google*/
/*eslint no-undef: "error"*/

//const map_data = map_data;
const markersarray = [];
let infowindow;
let bounds;
let prezoom;
let initZoom = 1;

function map_initialize() {
    // let wehaveactive = 'no';
    const map_div = document.getElementById('map1');
    if ($(window).width() < 600) {
        initZoom = map_data.zoomMobile;
    } else {
        initZoom = map_data.zoomDesktop;
    }
    const map_markers = map_data.markers,
        map_center = new google.maps.LatLng(map_data.center[0], map_data.center[1]),
        map_zoom = Number(initZoom);
    // minZoom = 1,
    // maxZoom = 16,
    const map = new google.maps.Map(map_div, {
        zoom: map_zoom,
        center: map_center,
        scrollwheel: false,
        zoomControl: true,
        streetViewControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    });
    bounds = new google.maps.LatLngBounds();
    if (map_markers.length) {
        infowindow = new google.maps.InfoWindow();
        let marker;
        let i;
        for (i = 0; i < map_markers.length; i++) {
            marker = new google.maps.Marker({
                position: new google.maps.LatLng(
                    map_markers[i]['latlang'][0],
                    map_markers[i]['latlang'][1]
                ),
                title: map_markers[i]['title'],
                map: map,
                icon: map_markers[i]['icon'],
                id: i
            });
            bounds.extend(marker.position);
            const precoordinates = map.getCenter();
            google.maps.event.addListener(marker, 'click', (function (marker, i) {
                return function () {
                    infowindow.close();
                    prezoom = map.getZoom();

                    infowindow.setContent(map_markers[i]['desc']);

                    infowindow.setOptions({id: i});
                    infowindow.open(map, marker);
                    map.setZoom(13);
                    map.setCenter(marker.getPosition());

                    google.maps.event.addListener(infowindow, 'closeclick', function () {
                        map.setZoom(prezoom);
                        map.setCenter(precoordinates);
                    });
                }
            })(marker, i));

            markersarray.push(marker);
            if (map_markers[i]['active'] === 'yes') {
                // wehaveactive = 'yes';
                infowindow.setContent(map_markers[i]['desc']);
                infowindow.open(map, marker);

                map.setZoom(13);
                map.setCenter(marker.getPosition());
                google.maps.event.addListener(infowindow, 'closeclick', function () {
                    map.setZoom(prezoom);
                    map.setCenter(precoordinates);
                });

            } else {
                if (map_markers.length == 1) {
                    infowindow.setContent(map_markers[0]['desc']);
                    infowindow.open(map, marker);
                }
            }
        }
    }
}

if ($("#map1").length !== 0) {
    google.maps.event.addDomListener(window, 'load', map_initialize);
}